import { useContext, useEffect, useState } from "react"
import { Button } from "@mui/material"
import { FasFaLock, FasFaPaperPlane, FasFaUnLock } from "../../ui/fontawesome"
import { AlertSuccess } from "../../ui/views/alerts"
import { BootStrapSpinner } from "../../ui/views/spinner"
import { isAdmin } from "../../../helpers/account"
import { TemplateCattleProofBlock } from "../../../templates/cattleproof/block"
import { useHerdHook } from "../../../hooks/herd.hook"
import { AdminCertifyOpenModalButton } from "../../ui/buttons/button-admin"
import { ApplicationContext } from "../../../providers/application.provider"
import { groupStatusEnum } from "../../../enums/group.status.enum"
import { useGroupTypesHook, useHerdGroupsHook } from "../../../hooks/groups.hook"
import { AnimalEditorGridComponent } from "./animal-editor-grid.component"
import { LockHerdFromGridComponent } from "./lock-herd-from-grid.component"
import { useParams } from "react-router-dom"
import TemplatesCattleProofCenterBlock from "../../../templates/cattleproof/center-block"
import './styles.scss'

interface IAnimalEditorComponent
{
    groupId?: string
    setTemplateTitle?: any
}

export const returnHerdColumns: string[] = [
    'ID', 'gid', 'ranch_name', 'location', 'archived_at', 'breed', 'eid', 'visual_tag', 'tag_color', 'death_date', 'is_available', 'cid', 'animal_disposed_at', 'percent_angus', 'is_disposed', 'tag_exchange_in_progress', 'decentralized_at', 'decentralizing'
];

export const AnimalEditorComponent = ({ groupId, setTemplateTitle }: IAnimalEditorComponent) => {
    const { groupid } = useParams()
    const [ gid, setGid ] = useState<string>(groupId || groupid || '')
    const [ successMessage ] = useState('')
    const [ update, setUpdate ] = useState(false)
    const [ toggleLock, setToggleLock ] = useState<boolean>(false)
    
    const { currentApp, setReload, formId, setFormId } = useContext(ApplicationContext);

    const { herdState, herd, lockable, setHerd, setRefreshHerd, setHerdState, rowCount } = useHerdHook(gid, returnHerdColumns, 25);
    const { setGroupState } = useHerdGroupsHook()
    const { groupTypes, groupTypesState } = useGroupTypesHook()
    const id = currentApp?.answers?.ID

    const onLockEvent = () => setToggleLock(true);

//    const groupApproved: boolean = currentApp?.answers?.status === groupStatusEnum.approved;
    const groupReady: boolean = currentApp?.answers?.status === groupStatusEnum.ready;
    // const groupPaid: boolean = ((currentApp?.answers?.paid || 0) === 1) && ((currentApp?.answers?.payment_status === 'success' || currentApp?.answers?.payment_status === null));

    const isEditable = () => {
        if(isAdmin())
            return currentApp?.answers?.status === groupStatusEnum.pending;

        if(!currentApp?.answers?.status)
            return true;

        if(groupReady)
            return true;

        return false;
    }
    
    const getType = () => {
        let t: string | JSX.Element = <BootStrapSpinner />
        groupTypes.map(r => {
            if(r.type_id === currentApp?.answers?.group_type)
                t = `My ${r.name}`
        })
        return t
    }

    if(update) {
        setRefreshHerd(true)
        setUpdate(false)
    }

    useEffect(() => {
        if(groupTypesState.ready && currentApp?.answers?.group_type)
            setTemplateTitle(getType())
    }, [ groupTypesState.ready, currentApp?.answers?.group_type ])

    useEffect(() => {
        if((herdState.ready && !currentApp?.answers && !formId && !groupId) && groupid) {
            setFormId(groupid)
            setReload(true)
        }
    }, [ herdState.ready, formId, currentApp?.answers, groupId, groupid ]);

    return (
        <TemplateCattleProofBlock
            title=''
            description={'Edit your animals below. Not all fields are editable.'}
            onBackEvent={() => window.location.reload() }
        >
        <div id="cattle-records">
            { (successMessage !== '')? <div className="mb-1"><AlertSuccess icon={<FasFaPaperPlane />} text={ successMessage } /></div> : '' }
            { !herdState.ready? <BootStrapSpinner /> :
                !isAdmin() && (herd.length > 0) && (
                <>
                <Button
                    color="primary"
                    className="py-3"
                    variant="outlined"
                    disabled={ !isEditable() || toggleLock || !lockable }
                    onClick={() => onLockEvent()}
                >
                    {!isEditable()? <FasFaLock /> : <FasFaUnLock /> }&nbsp;{ !isEditable()? 'Locked' : 'Commit' }
                </Button>
                { !lockable && toggleLock && <p className="alert alert-warning mt-3">This group can not be committed because there are unverified or used tags in this list.</p> }
                </>
                )
            }
            { (herdState.ready && gid !== '' && !update && isAdmin()) && <AdminCertifyOpenModalButton group={ currentApp.answers } /> }
            { herdState.loading? <div className="align-middle p-5 m-5"><BootStrapSpinner /></div> : '' }
            { herdState.ready && !toggleLock &&
                <AnimalEditorGridComponent
                    groupStatus={ currentApp.answers?.status || groupStatusEnum.ready }
                    herd={ herd }
                    rowCount={ rowCount }
                    gid={ gid }
                    setHerd={ setHerd }
                    herdState={ herdState }
                    setUpdate={ setUpdate }
                    isEditable={ isEditable }
                    update={ update }
                    setGroupsState={ setGroupState }
                    setRefreshHerd={ setRefreshHerd }
                    groupId={ gid }
                    setGid={ setGid }
                    setHerdState={ setHerdState }
                /> }
            { herdState.ready && toggleLock &&
                <TemplatesCattleProofCenterBlock
                    addClass="mt-2"
                    startClass="start2 py-4 span3-lg"
                >
                    <LockHerdFromGridComponent
                        id={id}
                        onSuccessLock={ () => setToggleLock(false) }
                        onCloseLock={ () => setToggleLock(false) }
                        group={ currentApp.answers }
                        setGid={setGid}
                    />
                </TemplatesCattleProofCenterBlock> }
        </div>
      </TemplateCattleProofBlock>
    )
}